import { render, staticRenderFns } from "./OpVerifyFrameReject.vue?vue&type=template&id=e665a1be&"
import script from "./OpVerifyFrameReject.vue?vue&type=script&lang=js&"
export * from "./OpVerifyFrameReject.vue?vue&type=script&lang=js&"
import style0 from "./OpVerifyFrameReject.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e665a1be')) {
      api.createRecord('e665a1be', component.options)
    } else {
      api.reload('e665a1be', component.options)
    }
    module.hot.accept("./OpVerifyFrameReject.vue?vue&type=template&id=e665a1be&", function () {
      api.rerender('e665a1be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaExport/components/verify/OpVerifyFrameReject.vue"
export default component.exports